<div class="one" fxLayout="column" [formGroup]="MatterPropertyDetailsForm">
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="20"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.PARENTVOLUME),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PARENTVOLUME),
      }"
    >
      <mat-label>Volume</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList.PARENTVOLUME?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="PARENTVOLUME"
      />
      @if (testBool && toolTipList.PARENTVOLUME) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.PARENTVOLUME.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.PARENTVOLUME?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="20"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.PARENTFOLIOID),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PARENTFOLIOID),
      }"
    >
      <mat-label>Folio Id</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList.PARENTFOLIOID?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="PARENTFOLIOID"
      />
      @if (testBool && toolTipList.PARENTFOLIOID) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.PARENTFOLIOID.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.PARENTFOLIOID?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="20"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.PARENTLOT),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PARENTLOT),
      }"
    >
      <mat-label>Lot</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList.PARENTLOT?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="PARENTLOT"
      />
      @if (testBool && toolTipList.PARENTLOT) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.PARENTLOT.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.PARENTLOT?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="20"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.PARENTPLANTYPE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PARENTPLANTYPE),
      }"
    >
      <mat-label>Plan Type</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList.PARENTPLANTYPE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="PARENTPLANTYPE"
      />
      @if (testBool && toolTipList.PARENTPLANTYPE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.PARENTPLANTYPE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.PARENTPLANTYPE?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="20"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.PARENTPLANNUMBER),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PARENTPLANNUMBER),
      }"
    >
      <mat-label>Plan No.</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList.PARENTPLANNUMBER?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="PARENTPLANNUMBER"
      />
      @if (testBool && toolTipList.PARENTPLANNUMBER) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.PARENTPLANNUMBER.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.PARENTPLANNUMBER?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      class="pr-1"
      fxFlex="25"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.PARENTCROWNALLOTMENT),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PARENTCROWNALLOTMENT),
      }"
    >
      <mat-label>Crown Allotment</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList.PARENTCROWNALLOTMENT?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="PARENTCROWNALLOTMENT"
      />
      @if (testBool && toolTipList.PARENTCROWNALLOTMENT) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.PARENTCROWNALLOTMENT.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.PARENTCROWNALLOTMENT?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      class="pr-1"
      fxFlex="25"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.PARENTCROWNBLOCK),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PARENTCROWNBLOCK),
      }"
    >
      <mat-label>Crown Block</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList.PARENTCROWNBLOCK?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="PARENTCROWNBLOCK"
      />
      @if (testBool && toolTipList.PARENTCROWNBLOCK) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.PARENTCROWNBLOCK.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.PARENTCROWNBLOCK?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      class="pr-1"
      fxFlex="25"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.PARENTCROWNSECTION),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PARENTCROWNSECTION),
      }"
    >
      <mat-label>Crown Section</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList.PARENTCROWNSECTION?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="PARENTCROWNSECTION"
      />
      @if (testBool && toolTipList.PARENTCROWNSECTION) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.PARENTCROWNSECTION.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.PARENTCROWNSECTION?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      class="pr-1"
      fxFlex="25"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.PARENTCROWNPORTION),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PARENTCROWNPORTION),
      }"
    >
      <mat-label>Crown Portion</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList.PARENTCROWNPORTION?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="PARENTCROWNPORTION"
      />
      @if (testBool && toolTipList.PARENTCROWNPORTION) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.PARENTCROWNPORTION.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.PARENTCROWNPORTION?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
</div>
